import React from 'react'

const features = [
  {
    icon: 'line-icon-Credit-Card2',
    title: 'Affordable Prices',
    text: "We believe cost shouldn't be a barrier to healthcare. 24Telemed services are accessible to everyone.",
    gradient: 'linear-gradient(135deg, #37514B 0%, #00b8b8 100%)',
    delay: '0s',
  },
  {
    icon: 'line-icon-Geo-',
    title: 'Rural, Suburban and Urban Areas',
    text: '24Telemed creates a robust virtual practice to treat patients across rural, suburban and urban communities. Our qualified physicians are ready to manage your symptoms.',
    gradient: 'linear-gradient(135deg, #1a4a42 0%, #4a6d65 100%)',
    delay: '0.15s',
  },
  {
    icon: 'line-icon-Timer',
    title: '24 Hour Service',
    text: 'Consult qualified specialists anytime using eConsult or the WhatsApp chat. Simple, accessible, and always available.',
    gradient: 'linear-gradient(135deg, #00b8b8 0%, #37514B 100%)',
    delay: '0.3s',
  },
]

export const AfterSlider = () => {
  return (
    <section
      id="start-now"
      style={{
        background: 'linear-gradient(180deg, #f0f9f9 0%, #ffffff 100%)',
        paddingTop: '2.5rem',
        paddingBottom: '5rem',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Decorative blobs */}
      <div style={{ position: 'absolute', width: 500, height: 500, background: 'rgba(0,184,184,0.07)', borderRadius: '50%', filter: 'blur(80px)', top: '-100px', right: '-150px', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', width: 350, height: 350, background: 'rgba(55,81,75,0.07)', borderRadius: '50%', filter: 'blur(60px)', bottom: '-50px', left: '-80px', pointerEvents: 'none' }} />

      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        {/* Feature Cards — use CSS animation class, no opacity:0 issue */}
        <div className="row justify-content-center" style={{ marginTop: '2rem' }}>
          {features.map((feat, i) => (
            <div key={i} className={`col-12 col-lg-4 col-md-6 col-sm-10 card-animate-in`} style={{ animationDelay: feat.delay, marginBottom: '1.5rem' }}>
              <FeatureCard feat={feat} />
            </div>
          ))}
        </div>

        {/* Stats Row */}
        <div className="row" style={{ marginTop: '4rem' }}>
          <div className="col-12">
            <div
              style={{
                background: 'linear-gradient(135deg, #37514B 0%, #1a4a42 50%, #00b8b8 100%)',
                borderRadius: 24,
                padding: '2.5rem 2rem',
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              <div style={{ position: 'absolute', top: '50%', left: '50%', width: 500, height: 500, background: 'rgba(0,184,184,0.08)', borderRadius: '50%', transform: 'translate(-50%,-50%)', pointerEvents: 'none' }} />

              <div className="row justify-content-center" style={{ position: 'relative', zIndex: 1 }}>
                {[
                  { number: '24/7', label: 'Hours Available' },
                  { number: '10K+', label: 'Patients Served' },
                  { number: '50+', label: 'Specialists' },
                  { number: '98%', label: 'Satisfaction Rate' },
                ].map((stat, i) => (
                  <div
                    key={i}
                    className="col-6 col-md-3"
                    style={{
                      textAlign: 'center',
                      padding: '1rem',
                      borderRight: i < 3 ? '1px solid rgba(255,255,255,0.15)' : 'none',
                    }}
                  >
                    <div style={{ fontSize: 'clamp(1.8rem, 4vw, 2.8rem)', fontWeight: 800, color: '#fff', lineHeight: 1.1, marginBottom: '0.4rem', textShadow: '0 0 20px rgba(0,184,184,0.5)' }}>
                      {stat.number}
                    </div>
                    <div style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', letterSpacing: 2, fontWeight: 500 }}>
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

const FeatureCard = ({ feat }) => {
  const [hovered, setHovered] = React.useState(false)
  return (
    <div
      style={{
        background: '#ffffff',
        borderRadius: 24,
        padding: '2.5rem 2rem',
        boxShadow: hovered ? '0 30px 80px rgba(0,0,0,0.18)' : '0 20px 60px rgba(0,0,0,0.1)',
        border: '1px solid rgba(0,184,184,0.12)',
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        transform: hovered ? 'translateY(-12px)' : 'translateY(0)',
        cursor: 'default',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Top gradient line */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 4, background: feat.gradient, borderRadius: '24px 24px 0 0' }} />

      {/* Animated BG fill on hover */}
      <div
        style={{
          position: 'absolute',
          bottom: hovered ? '-10%' : '-160%',
          left: '-10%',
          width: '120%',
          height: '130%',
          background: feat.gradient,
          transition: 'bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
          borderRadius: '60% 60% 0 0',
          zIndex: 0,
        }}
      />

      {/* Icon */}
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: 16,
          background: hovered ? 'rgba(255,255,255,0.2)' : 'rgba(0,184,184,0.12)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '1.5rem',
          position: 'relative',
          zIndex: 1,
          transition: 'all 0.4s ease',
        }}
      >
        <i
          className={`${feat.icon} icon-medium`}
          style={{ fontSize: '1.8rem', color: hovered ? '#fff' : '#00b8b8', transition: 'color 0.4s ease' }}
        />
      </div>

      {/* Title */}
      <div style={{ fontSize: '1.1rem', fontWeight: 700, color: hovered ? '#fff' : '#1a2332', marginBottom: '0.75rem', position: 'relative', zIndex: 1, transition: 'color 0.4s ease' }}>
        {feat.title}
      </div>

      {/* Text */}
      <div style={{ fontSize: '0.9rem', color: hovered ? 'rgba(255,255,255,0.85)' : '#6b7280', lineHeight: 1.75, position: 'relative', zIndex: 1, transition: 'color 0.4s ease' }}>
        {feat.text}
      </div>
    </div>
  )
}
